import axios from "axios";

const App = async (androidCurrentVersion: string) => {
    try {
        const response = await axios.get('https://down.gtokentool.com/version.json', {
            headers: { 'Cache-Control': 'no-cache' }, // 禁用缓存
            timeout: 10000,
            validateStatus: (status) => status >= 200 && status < 300,
        });

        const androidUpdateInfo = response.data?.data;
        if (!androidUpdateInfo || !androidUpdateInfo.latestVersion) {
            throw new Error('服务器未返回安卓版本信息');
        }

        const needUpdate = isNeedUpdate(androidCurrentVersion, androidUpdateInfo.latestVersion);
        console.log(`版本对比：当前${androidCurrentVersion} | 最新${androidUpdateInfo.latestVersion} | 是否需要更新：${needUpdate}`);
        return needUpdate


    } catch (err) {
        console.error('检测安卓新版本失败：', err);
        return false
    }
};

// 核心修复：语义化版本对比工具函数（判断v1是否低于v2，即是否需要更新）
const isNeedUpdate = (currentVersion: string, latestVersion: string): boolean => {
    if (!currentVersion || !latestVersion) return false;

    // 拆分版本号为数字数组（处理 1.0 / 0.0.6 这种长度不一致的情况）
    const currentArr = currentVersion.split('.').map(Number);
    const latestArr = latestVersion.split('.').map(Number);
    const maxLength = Math.max(currentArr.length, latestArr.length);

    // 逐位对比版本号
    for (let i = 0; i < maxLength; i++) {
        const currentNum = currentArr[i] || 0;
        const latestNum = latestArr[i] || 0;

        if (currentNum < latestNum) {
            return true; // 当前版本更低，需要更新
        } else if (currentNum > latestNum) {
            return false; // 当前版本更高，无需更新
        }
    }
    return false; // 版本相同，无需更新
};
export default App